export default {
  'pages.info.more': '更多资讯',
  'pages.info.page': '换一批',
  'pages.info.content': '相关资讯',
};
